import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import { userSlice } from "../redux/user/userSlice";
import { Tooltip } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyAvaileble from "./KeyAvaileble";

import "../index.css";

const { selectProject } = userSlice;

const prodURL = "https://club-lab.ru";
const url =
  window.location.hostname === "localhost" ? "http://localhost:3004" : prodURL;

export default function Author() {
  const dispatch = useDispatch();

  const [gamesData, setGamesData] = useState([]);

  const data = useSelector((state) => state.user?.games);
  const profile = useSelector((state) => state.user?.profile);

  useEffect(() => {
    if (data) {
      setGamesData(data);
    }
  }, [data]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <KeyAvaileble limit={profile?.limit} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "800px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "20px",
            // padding: "20px 20px",
            flexWrap: "wrap",
            justifyContent: "space-around",
          }}
        >
          {!gamesData.length ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                maxWidth: "1440px",
                width: "100%",
              }}
            >
              <div style={{ fontSize: "24px", fontWeight: "bold" }}>
                Вы еще не создали свой первый сценарий
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                flexWrap: "wrap",
              }}
            >
              <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                {gamesData?.map((el) => {
                  return (
                    <div
                      key={el._id}
                      style={{
                        border: "2px solid #2F5478",
                        width: "340px",
                      }}
                    >
                      <div style={{ textAlign: "center", padding: "5px 0" }}>
                        {el.title}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        {el.poster ? (
                          <div
                            className="image-preview"
                            style={{
                              boxSizing: "border-box",
                              width: "250px",
                              height: "200px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <img src={`${url}/${el.poster}`} alt="Uploaded" />
                          </div>
                        ) : (
                          <div className="upload-container">
                            <div className="upload-icon">
                              <NoPhotographyIcon />
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ padding: "5px 3px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "5px 15px",
                          }}
                        >
                          <Tooltip title="Настройки проекта" placement="top">
                            <Link
                              to={`/main/${el._id}`}
                              state={{ projectId: el._id, type: "settings" }}
                            >
                              <SettingsIcon
                                sx={{ cursor: "pointer" }}
                                onClick={() => dispatch(selectProject(el._id))}
                              />
                            </Link>
                          </Tooltip>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "3px 0",
                          }}
                        >
                          Статус проекта:
                          <div>
                            {el.settings.published ? "Опубликован" : "В работе"}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "3px 0",
                          }}
                        >
                          Количество сцен:
                          <div>
                            {
                              el.nodes?.filter((el) => el.type === "group")
                                ?.length
                            }
                          </div>
                        </div>
                        {/* <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "3px 0",
                          }}
                        >
                          Доступ:
                          <div>
                            {el.settings.private_access ? "Частный" : "Общий"}
                          </div>
                        </div> */}
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "3px 0",
                          }}
                        >
                          Контент 18+
                          <div>{el.settings.adult_content ? "Да" : "Нет"}</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "3px 0",
                          }}
                        >
                          Описание сценария:
                          <div>{el.description ? "Да" : "Нет"}</div>
                        </div>
                        {/* <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            padding: "3px 0",
                          }}
                        >
                          Количество просмотров:
                          <div>{el.description ? "Да" : "Нет"}</div>
                        </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
